
import { Injectable, inject, DOCUMENT } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../environments/environment";

export interface ToastConfig {
  severity: string;
  summary: string;
  detail: string;
}

export interface DialogConfig {
  header: string;
  message: string;
  icon?: string;
  rejectButtonStyleClass?: string;
  acceptIcon?: string;
  rejectIcon?: string;
  modal?: boolean;
  accept?: () => void;
}

export interface UpdateConfig {
  version: string;
  action: string;
}

@Injectable({
  providedIn: 'root'
})

export class AppService {
  private document = inject<Document>(DOCUMENT);

  private updateSubject = new BehaviorSubject<UpdateConfig | null>(null);
  public update = this.updateSubject.asObservable();
  private toastSubject = new BehaviorSubject<ToastConfig | null>(null);
  public toast = this.toastSubject.asObservable();
  private dialogSubject = new BehaviorSubject<DialogConfig | null>(null);
  public dialog = this.dialogSubject.asObservable();
  private themeSubject = new BehaviorSubject<string | null>(null);
  public theme = this.themeSubject.asObservable();

  public showUpdate(data: UpdateConfig): void {
    this.updateSubject.next(data);
  }

  public showToast(message: ToastConfig): void {
    this.toastSubject.next(message);
  }

  public showDialog(dialog: DialogConfig): void {
    this.dialogSubject.next(dialog);
  }

  public switchTheme(theme: string): void {
    const htmlElement = this.document.querySelector('html');

    if (theme === 'dark') {
      htmlElement?.classList.add('doc-app-dark');
    } else {
      htmlElement?.classList.remove('doc-app-dark');
    }
    this.themeSubject.next(theme);
    localStorage.setItem('doktorijum_theme', theme);
  }

  public async initReverb(): Promise<void> {
    const [{ default: Pusher }, { default: Echo }] = await Promise.all([
      import('pusher-js'),
      import('laravel-echo'),
    ]);
    (window as any)['Pusher'] = Pusher;
    (window as any)['Echo'] = new Echo({
      broadcaster: 'reverb',
      key: environment.reverb.appKey,
      wsHost: environment.reverb.host,
      wsPort: environment.reverb.wsPort,
      wssPort: environment.reverb.wssPort,
      forceTLS: (environment.reverb.scheme ?? 'https') === 'https',
      authEndpoint: `${environment.reverb.scheme}://${environment.reverb.host}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(environment.accessTokenName),
        },
      },
      enabledTransports: ['ws', 'wss'],
    });
  }

}